import {CdoDocumentRequest} from '../../interfaces/customer-documents/cdo-document-request';

export class CdoDocumentRequestFactory {

  /**
   *
   * @param cdoDocumentRequest
   */
  public static fromObject(cdoDocumentRequest: any): CdoDocumentRequest {
    return new class implements CdoDocumentRequest {
      customerId: number = cdoDocumentRequest.customer_id ?? cdoDocumentRequest.customerId;
      cdoDocumentTypeId: number = cdoDocumentRequest.cdo_document_type_id ?? cdoDocumentRequest.cdoDocumentTypeId;
      comment: string = cdoDocumentRequest.comment ?? null;
      dueDate: string = cdoDocumentRequest.due_date ?? cdoDocumentRequest.dueDate ?? null;
      userId: number = cdoDocumentRequest.user_id ?? cdoDocumentRequest.userId;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = cdoDocumentRequest.id;
      uuid: string = cdoDocumentRequest.uuid;
      modified: string = cdoDocumentRequest.modified;
      created: string = cdoDocumentRequest.created;
    };
  }

  /**
   *
   * @param cdoDocumentRequests
   */
  public static fromArray(cdoDocumentRequests: any[]): CdoDocumentRequest[] {
    return cdoDocumentRequests.map(_cdoDocumentRequest => this.fromObject(_cdoDocumentRequest));
  }

  /**
   *
   * @param cdoDocumentRequest
   */
  public static toRemote(cdoDocumentRequest: CdoDocumentRequest): any {
    return {
      customer_id: cdoDocumentRequest.customerId,
      cdo_document_type_id: cdoDocumentRequest.cdoDocumentTypeId,
      comment: cdoDocumentRequest.comment,
      due_date: cdoDocumentRequest.dueDate
    };
  }

  /**
   *
   * @param cdoDocumentRequest
   */
  public static new(cdoDocumentRequest: Partial<CdoDocumentRequest> = {}): CdoDocumentRequest {
    const newCdoDocumentRequest: CdoDocumentRequest = new class implements CdoDocumentRequest {
      customerId: number = null;
      cdoDocumentTypeId: number = null;
      comment: string = null;
      dueDate: string = null;
      userId: number = null;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
    };

    return { ...newCdoDocumentRequest, ...cdoDocumentRequest };
  }

}
